import requests from "./httpService";

const FoodMasterMenuService = {
  addMenu(body) {
    return requests.post("/school-food-menu/master/add", body);
  },

  updateMenu(id, body) {
    return requests.put(`/school-food-menu/master/${id}`, body);
  },

  deleteMenu(id) {
    return requests.delete(`/school-food-menu/master/${id}`);
  },

  listBySchool(schooleId, includeInactive = false) {
    return requests.get(
      `/school-food-menu/master/school/${schooleId}?includeInactive=${includeInactive ? "true" : "false"}`
    );
  },
};

export default FoodMasterMenuService;
